/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

export type EmailArchiveBrowseControllerListEmailsSort =
  (typeof EmailArchiveBrowseControllerListEmailsSort)[keyof typeof EmailArchiveBrowseControllerListEmailsSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailArchiveBrowseControllerListEmailsSort = {
  relevance: 'relevance',
  recent: 'recent',
  oldest: 'oldest',
  quality: 'quality',
} as const;
